import { render, staticRenderFns } from "./nestedInfoCard.vue?vue&type=template&id=4e568d2c"
import script from "./nestedInfoCard.vue?vue&type=script&lang=js"
export * from "./nestedInfoCard.vue?vue&type=script&lang=js"
import style0 from "./nestedInfoCard.vue?vue&type=style&index=0&id=4e568d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports